const HamburgerIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width='24'
      height='10'
      viewBox='0 0 24 10'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.20324e-07 1L24 1'
        stroke='currentColor'
        strokeWidth='2'
      />
      <path
        d='M3.20324e-07 9L24 9'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  );
};

export default HamburgerIcon;
